import StockHolderSearch from "./stockHolderSearch.container";

export default StockHolderSearch;
